export function dateInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function dateTimeInputValue(date: Date): string {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${dateInputValue(date)}T${hours}:${minutes}`;
}

export function mergeDateAndTime(date: string, time?: string): Date {
  const result = new Date(`${date}T00:00:00`);
  if (time) {
    const [hours, minutes] = time.split(':').map(Number);
    result.setHours(hours ?? 0, minutes ?? 0, 0, 0);
  }
  return result;
}

export function epochSecondsFromNow(hours: number): number {
  return Math.floor((Date.now() + hours * 3_600_000) / 1000);
}